export default {
  loginTitle: 'Login in',
  noAccount: 'No Account?',
  createAccount: 'Create Account',
  remember: 'Remember Account',
  forget: 'Forget Account',
  signIn: 'Sign in',
  existAccount: 'Exist Account?',
  refresh: 'refresh',
  wechatLogin: 'Login with WeChat',
  accountLogin: 'Login with Account',
  phoneLogin: 'Login with Mobile Phone',
  input: {
    account: 'please enter account',
    password: 'please enter password',
    phone: 'please enter phone',
    verification: 'please enter verification code',
  },
  required: {
    account: 'account is required',
    phone: 'phone is required',
    password: 'password is required',
    verification: 'verification code is require',
  },
  sendVerification: 'send',
};
